export default __webpack_public_path__ + "media/images/icons_fc/graphbleu-815c49169d873beb2c41d7c30e887f50.png";